<template>
  <div>
    <b-form-input @input="inputHandler" v-model="message" :placeholder="placeholder"></b-form-input>
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    placeholder: [String]
  },
  data(){
    return{
      message: '',
    }
  },
  methods: {
    inputHandler(){
      this.$emit('inputMessage', this.message)
    },
  }
}
</script>

<style scoped>

</style>
